import {
  CoreFlightsRebookComponent,
  useFlightsRebookStyles,
} from "@b2bportal/core-flights-rebook";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  Button,
} from "@b2bportal/core-ui";
import { useRebookErrorModal } from "@tenant/flights-rebook";
import defaultStyles from "./RebookErrorModal.module.scss";
import type { RebookErrorModalProps } from "./types";

export const RebookErrorModal = ({
  className,
  children,
  ...props
}: RebookErrorModalProps) => {
  const COMPONENT_KEY = CoreFlightsRebookComponent.RebookErrorModal;
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context } = useRebookErrorModal(props);

  return (
    <AlertDialog open={context.isOpen}>
      <AlertDialogContent
        className={block}
        title={context.message.title}
        description={context.message.subtitle}
        actions={
          context.actions.length > 0
            ? context.actions.map((action, index) => (
                <AlertDialogAction asChild key={index}>
                  <Button
                    buttonType={action.buttonType}
                    className={action.className}
                    onClick={action.action}
                  >
                    {action.label}
                  </Button>
                </AlertDialogAction>
              ))
            : null
        }
      />
    </AlertDialog>
  );
};
